export default "__VITE_ASSET__3e1f97ff__"